export const PUBLISHED_STATUS = "PUBLISHED";

export const ARTICLE_IS_DOCX = "docx";
export const ARTICLE_IS_PDF = "pdf";

export const SUPPORTED_ARTICLE_DOCUMENTS = [
  ARTICLE_IS_DOCX,
  ARTICLE_IS_PDF
];
